export default function usersToSelectOptions(users) {
    const userIds = Object.keys(users);
    return userIds.map((userId) => {
        const user = users[userId];
        return {
            value: user.id,
            label: user.name ? `${user.name} ${user.surname}` : user.email
        };
    });
} 